import {inject} from '@angular/core';
import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {take} from 'rxjs/operators';
import {DomainValueMapDTO} from '../models/DomainValueMapDTO';
import {DomainValueMapService} from '../services/domain-value-map.service';

interface MessageDirectionState {
  directionsByRouteId: Record<string, string>;
  loaded: boolean;
  loading: boolean;
}

const initialState: MessageDirectionState = {
  directionsByRouteId: {},
  loaded: false,
  loading: false
};


export const MessageDirectionStore = signalStore(
  {providedIn: 'root'},
  withState(initialState),
  withMethods((store, domainValueMapService = inject(DomainValueMapService)) => ({
    loadDirections(): void {
      if (store.loaded() || store.loading()) {
        return;
      }

      patchState(store, {loading: true});
      domainValueMapService.getMessageDirections()
        .pipe(take(1))
        .subscribe({
          next: (mappings: DomainValueMapDTO[]) => {
            const directionsByRouteId = mappings.reduce((result, mapping) => {
              result[mapping.sourceValue] = mapping.targetValue;
              return result;
            }, {} as Record<string, string>);
            patchState(store, {directionsByRouteId, loaded: true, loading: false});
          },
          error: (error) => {
            console.error('Failed to load message directions:', error);
            patchState(store, {directionsByRouteId: {}, loaded: false, loading: false});
          }
        });
    },

    getDirection(routeId: string): string {
      return routeId ? store.directionsByRouteId()[routeId] ?? '' : '';
    }
  }))
);
